"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var R = _interopRequireWildcard(require("ramda"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _DeliveryAddressForm = _interopRequireDefault(require("../DeliveryAddressForm/DeliveryAddressForm"));

var _gift = require("../../shapes/gift.shape");

var _gift2 = require("../../store/gift/gift.selector");

var _invitationType = require("../../store/gift/invitationType/invitationType.actions");

var _invitationType2 = require("../../store/gift/invitationType/invitationType.selectors");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    addresses: {
      padding: spacing(2)
    },
    title: {
      paddingTop: spacing(2)
    }
  };
});

var ManualAddressForm = function ManualAddressForm(_ref2) {
  var isVisible = _ref2.isVisible,
      mockAddress = _ref2.mockAddress,
      recipient = _ref2.recipient,
      onChange = _ref2.onChange;
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var errors = (0, _reactRedux.useSelector)(_invitationType2.getInvitationTypeErrors);
  var countryId = (0, _reactRedux.useSelector)(_gift2.getGiftRecipientCountryId);
  var defaultAddress = (0, _reactRedux.useSelector)(_invitationType2.getSelectedInvitationTypeContactAddress);
  var emptyAddress = (0, _react.useMemo)(function () {
    return {
      address_line_1: '',
      address_line_2: '',
      state: '',
      stateCode: '',
      zip: '',
      city: '',
      country_id: countryId,
      phone: ''
    };
  }, [countryId]);

  var _useState = (0, _react.useState)(defaultAddress || emptyAddress),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      address = _useState2[0],
      setAddress = _useState2[1];

  var onAddressChange = (0, _react.useCallback)(function (changes) {
    setAddress(_objectSpread(_objectSpread({}, address), changes));
  }, [address]);
  var onAddressFieldFocus = (0, _react.useCallback)(function (field) {
    return dispatch((0, _invitationType.clearError)(['contact_address', field]));
  }, [dispatch]);
  /**
   * Clear address mocks when
   * And if default address is mock, then form will be erased.
   */

  (0, _react.useEffect)(function () {
    var isMockAddress = R.equals(mockAddress, defaultAddress);

    if (isVisible) {
      setAddress(!defaultAddress || isMockAddress ? emptyAddress : defaultAddress);
    }
  }, [defaultAddress, emptyAddress, isVisible, mockAddress]);
  /**
   * Emit updated form on input changes of delivery form
   */

  (0, _react.useEffect)(function () {
    return onChange(address);
  }, [address, onChange]);
  return /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    direction: "down",
    in: isVisible,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column",
    className: classes.addresses
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('H4-Dark', classes.title)
  }, "Great choice! What\u2019s ", recipient, "\u2019s address?"), /*#__PURE__*/_react.default.createElement(_DeliveryAddressForm.default, {
    address: address,
    errors: errors && errors.contact_address,
    onFocus: onAddressFieldFocus,
    onUpdateField: onAddressChange
  })));
};

ManualAddressForm.propTypes = {
  mockAddress: _gift.InvitationItemAddressShape.isRequired,
  onChange: _propTypes.default.func.isRequired,
  recipient: _propTypes.default.string.isRequired,
  isVisible: _propTypes.default.bool
};
ManualAddressForm.defaultProps = {
  isVisible: true
};

var _default = /*#__PURE__*/(0, _react.memo)(ManualAddressForm);

exports.default = _default;